//====================================================
//  Function: Parallax
//====================================================
function componentParallax() {
  if ($('.js-parallax').length) {
    var parallaxImages = document.querySelectorAll('.js-parallax')
    new simpleParallax(parallaxImages, {
      delay: 2,
      orientation: 'down',
      scale: 1.4,
    })
  }

  if ($('.js-parallax-down').length) {
    var parallaxImages = document.querySelectorAll('.js-parallax-down')
    new simpleParallax(parallaxImages, {
      delay: 0.8,
      orientation: 'down',
      scale: 1.2,
    })
  }

  if ($('.js-parallax-small').length) {
    var parallaxImages = document.querySelectorAll('.js-parallax-small')
    new simpleParallax(parallaxImages, {
      delay: 0.8,
      scale: 1.05,
    })
  }

  if ($('.js-hero-section').length) {
    gsap.from('.js-hero-image', {
      transform: 'translate3d(0, -250px , 0)',
      ease: 'none',
      scrollTrigger: {
        trigger: '.js-hero-section',
        end: 'top',
        scrub: 2,
      },
    })
  }
}
